import { Spin, message } from 'taxaroo-ui';
import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useConnectExternalCalendarMutation } from 'src/graphql/mutations/appointments';

const ExternalCalendarRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const [connectExternalCalendar, { data, loading }] = useConnectExternalCalendarMutation();

  useEffect(() => {
    const code = new URLSearchParams(location.search).get('code');
    const state = new URLSearchParams(location.search).get('state');
    const provider = params.provider.toUpperCase();
    if (code && provider && state) {
      connectExternalCalendar({
        variables: { code, provider, state },
        onCompleted: () => {
          navigate('/settings/calendars');
        },
        onError: (error) => {
          navigate('/settings/calendars');
          message.error(error.message);
        },
      });
    }
  }, [location.search]);

  return <Spin fullscreen />;
};

export default ExternalCalendarRedirect;
